import { useContext } from 'react';
import SecurityContext, { SecurityContextContent } from '../SecurityContext';

export default (): SecurityContextContent => useContext(SecurityContext);
